module.exports = __webpack_public_path__ + "static/media/MidwestTimes-socshare-min.53f3a127.jpg";